import Cookies from 'js-cookie'

const TokenKey = 'access-token'

export function getToken() {
    return Cookies.get(TokenKey)
}

export function setToken(token) {
    return Cookies.set(TokenKey, token)
}

export function removeToken() {
    return Cookies.remove(TokenKey)
}


// sessionStorage
export function getItem(item) {
    return sessionStorage.getItem(item)
}

export function setItem(key, item) {
    return sessionStorage.setItem(key, item)
}

export function removeItem(item) {
    return sessionStorage.removeItem(item)
}